import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from '../../redux/actions/userActions';
import './index.scss';
import { Form, Loading, Toast } from '../../components';
import { INFORMATION_PATH, LOGIN_PAGE_PATH } from '../../routes/path';

const RegisterScreen = () => {
  const [form, setForm] = useState({
    nombre: '',
    password: '',
    apellido: '',
    email: '',
    telefono: '',
    dni: '',
  });

  const [isRegisterFormValid, setIsRegisterFormValid] = useState({
    nombre: true,
    password: true,
    apellido: true,
    email: true,
    telefono: true,
    dni: true,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn, error, isLoadingUser } = useSelector((state) => state.userReducer);

  useEffect(() => {
    if (isLoggedIn) navigate(INFORMATION_PATH);
  }, [isLoggedIn]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(registerUser({ ...form }));
  };

  const handleRegisterClick = () => {
    navigate(LOGIN_PAGE_PATH);
  };

  const formRegister = [{
    type: 'text',
    id: 'nombre',
    text: 'Nombre'
  }, {
    type: 'text',
    id: 'apellido',
    text: 'Apellido'
  }, {
    type: 'text',
    id: 'dni',
    text: 'DNI'
  }, {
    type: 'text',
    id: 'telefono',
    text: 'Telefono'
  }, {
    type: 'email',
    id: 'email',
    text: 'Email'
  }, {
    type: 'password',
    id: 'password',
    text: 'Contraseña'
  }];

  const textForms = {
    title: 'Registro',
    secondButton: 'Iniciar sesión',
    firstButton: 'Registrarse',
  };
  if (isLoadingUser) return <Loading />;

  return (
    <div className="register">
      <Toast error={error} />
      <Form
        handleSubmit={handleSubmit}
        formData={formRegister}
        form={form}
        setForm={setForm}
        handleClick={handleRegisterClick}
        textForms={textForms}
        isLoginFormValid={isRegisterFormValid}
        setIsLoginFormValid={setIsRegisterFormValid}
      />
    </div>
  );
};

export default RegisterScreen;
